/**
 * TimelineNumberRow — `timeline[row].number` / `timeline[column].number`
 * renderer. Paints a per-column numeric annotation from the parent
 * `(number, scalar)` source's cells (a cell write is the SDK row's).
 */
import type { Option } from "../../core/option.ts";
import type { NaiveDate } from "@tento-chrono";

import { RendererRow } from "./renderer-row.ts";
import { SourceCells } from "./source-cells.ts";
import { SourceRow } from "./source-row.ts";

/**
 * The timeline number renderer row (`timeline[row].number` / `timeline[column].number`): paints
 * its source row's numbers per column.
 */
export class TimelineNumberRow extends RendererRow {
  get source(): SourceRow {
    const p = this.parent;
    if (!(p instanceof SourceRow)) {
      throw new Error(
        `TimelineNumberRow: parent of ${this.id.rawId} is not a SourceRow ` +
          `(got ${p?.constructor.name ?? "undefined"}).`,
      );
    }
    return p;
  }

  peekNumber(date: NaiveDate.Partial): Option<number> {
    const cell = SourceCells.dates(this.source.peekCells(date.toRange()))[0];
    return cell == null ? null : (cell.value as Option<number>);
  }
}
